import React from "react";

import classes from "./styles.module.css";

const BASE_URL = import.meta.env.VITE_APP_API_URL;

const DownloadReportButton = ({ slug, text }) => {
	return (
		<a className={classes.downloadLink} href={`${BASE_URL}${slug}`} download>
			{text}
		</a>
	);
};

export default DownloadReportButton;
